import {useDictAll} from '../../../Utils/Hooks/useDict';

export function useDict() {
    return useDictAll(['RoleList']);
}
